module.exports = __webpack_public_path__ + "202669:9205d1a92be8207f1496/img/featured-section@2x.2658df3.gif";